/**
 * Web-specific route mappings for clean, web-friendly URLs.
 */
export const REPORT_ROUTE_MAP: Record<string, string> = {
  // Reports
  REPORT_ALL_FRONTLINE_CLIENTS: 'all-frontline-clients',
  REPORT_ALL_GEN0_CLIENTS: 'all-gen0-clients',
  REPORT_ALL_ORGANIZATION_CLIENTS: 'all-organization-clients',
  REPORT_NEW_FRONTLINE_CLIENTS: 'new-frontline-clients',
  REPORT_NEW_GEN0_CLIENTS: 'new-gen0-clients',
  REPORT_NEW_ORGANIZATION_CLIENTS: 'new-organization-clients',
  REPORT_ALL_FRONTLINE_ORDERS: 'all-frontline-orders',
  REPORT_ALL_ORDERS: 'all-orders',
  REPORT_ALL_GEN0_ORDERS: 'all-gen0-orders',
  REPORT_ALL_ORGANIZATION_ORDERS: 'all-organization-orders',
  REPORT_NEW_FRONTLINE_ORDERS: 'new-frontline-orders',
  REPORT_NEW_GEN0_ORDERS: 'new-gen0-orders',
  REPORT_NEW_ORGANIZATION_ORDERS: 'new-organization-orders',
  REPORT_PREMIER_CANCELLATIONS: 'premier-cancellations',
  REPORT_PROJECTED_PREMIER_VOLUME: 'projected-premier-volume',
  REPORT_NEW_CLIENTS_WITHOUT_ORDERS: 'new-clients-without-orders',
  REPORT_RANK_UP: 'rank-up',
  REPORT_ELIGIBLE_FOR_CAB: 'eligible-for-cab',
  REPORT_ELIGIBLE_FOR_QSB: 'eligible-for-qsb',
  REPORT_CLOSE_TO_EXECUTIVE_DIRECTOR_RANK: 'close-to-ed-rank',
  REPORT_CLOSE_TO_FIBC_RANK: 'close-to-fibc-rank',
  REPORT_CLOSE_TO_SENIOR_COACH_RANK: 'close-to-sc-rank',
  REPORT_TEAMS_EXECUTIVE_DIRECTOR: 'teams-ed',
  REPORT_TEAMS_FIBC: 'teams-fibc',
  REPORT_TEAMS_FIBL: 'teams-fibl',
  REPORT_TEAMS_SENIOR_COACH: 'teams-sc',
  REPORT_EXPIRING_COACH_RENEWAL: 'expiring-coach-renewal',
  REPORT_COACHES_AT_RANK: 'coaches-at-rank',
  REPORT_COACHES_BELOW_RANK: 'coaches-below-rank',
  REPORT_COACHES_ABOVE_RANK: 'coaches-above-rank',
  REPORT_ALL_FRONTLINE_COACHES: 'all-frontline-coaches',
  REPORT_FRONTLINE_COACHES: 'frontline-coaches',
  REPORT_NEW_FRONTLINE_COACHES: 'new-frontline-coaches',
  REPORT_ALL_GEN0_COACHES: 'all-gen0-coaches',
  REPORT_NEW_GEN0_COACHES: 'new-gen0-coaches',
  REPORT_ALL_COACHES_IN_ORGANIZATION: 'all-organization-coaches',
  MY_TEAMS: 'my-teams-list',
  REPORT_NEW_COACHES_IN_ORGANIZATION: 'new-organization-coaches',
  REPORT_EARNED_CAB: 'earned-cab',
  REPORT_EARNED_QSB: 'earned-qsb',
  REPORT_ELIGIBLE_ACCELERATOR_BONUS: 'eligible-accelerator-bonus',
  REPORT_ELIGIBLE_CLIENT_SUPPORT_THREE_FOUR: 'eligible-csbp-3-4',
  REPORT_ELIGIBLE_CLIENT_SUPPORT_FIVE_SIX: 'eligible-csbp-5-6',
  REPORT_ELIGIBLE_CLIENT_SUPPORT_SEVEN_NINE: 'eligible-csbp-7-9',
  REPORT_ELIGIBLE_CLIENT_SUPPORT_ONE_TWO: 'eligible-csbp-1-2',
  REPORT_ELIGIBLE_CLIENT_SUPPORT_BONUS_PLUS: 'eligible-csbp-plus',
  REPORT_EARNED_CLIENT_SUPPORT_BONUS_PLUS: 'earned-csbp-plus',
  REPORT_EARNED_ACCELERATOR_BONUS: 'earned-accelerator-bonus',
  REPORT_NOT_CERTIFIED: 'not-certified',
  REPORT_INACTIVE_CLIENTS: 'inactive-clients',
  REPORT_EXPIRING_WELLNESS: 'expiring-wellness',
  REPORT_EXPIRING_REWARDS: 'expiring-rewards',
  REPORT_CLIENT_TO_CONTACT: 'people-to-contact',
  REPORT_ELIGIBLE_FOR_INCENTIVE_TRIP: 'eligible-incentive-trip',
  REPORT_QUALIFIED_FOR_INCENTIVE_TRIP: 'qualified-incentive-trip',
  REPORT_ALL_CANDIDATES: 'all-candidates',
  REPORT_BUSINESS_BUILDER_COACHES: 'business-builder-coaches',
  REPORT_VOLUME_PERFORMANCE: 'volume-performance',
  REPORT_ALL_REFERRALS: 'all-referrals',
  'myteams-data': 'myteams-data',

  // Screens / Modals
  ORDER_HISTORY_LIST_SCREEN: 'order-history',
  NOTIFICATIONS: 'notifications',
  TESTING_OPTIONS: 'testing-options',
  ACCOUNT_SETTINGS: 'account-settings',
  NOTIFICATION_SETTINGS: 'notification-settings',
  SECURITY_SETTINGS: 'security-settings',
  BONUSES: 'bonuses',
  SEARCH: 'search',
  RELEASE_NOTES: 'release-notes',
  CLIENT_PROFILE: 'client-profile',
  COACH_PROFILE: 'coach-profile',
  CANDIDATE_PROFILE: 'candidate-profile',
  REFERRAL_PROFILE: 'referral-profile',
  CREATE_NEW_CANDIDATE: 'create-candidate',
  SHARE_OPTAVIA_PLAN: 'share-plan',
  EDGE365CHALLENGESCREEN: 'edge365-challenge',
  MANAGE_MY_SITE: 'manage-my-site',
  HEALTH_CARE_PROVIDER: 'health-care-provider',
  SUPPORTED_LANGUAGES: 'supported-languages',
  LEADS_POOL: 'leads-pool',
};

export const MAIN_SCREENS_ROUTES = {
  dashboard: {
    path: 'dashboard',
    screens: {
      nextTask: '',
    },
  },
  performance: 'performance',
  teams: 'teams',
  watchlist: {
    path: '/teams/my-teams-list',
    screens: {
      'records-main-screen': '',
    },
  },
  clients: {
    path: 'clients',
    screens: {
      nextTask: '',
    },
  },
  profile: 'profile',
  'authorization-form': 'login',
};

// Create reverse mapping for incoming clean URLs
export const REVERSE_REPORT_ROUTE_MAP: Record<string, string> = Object.entries(
  REPORT_ROUTE_MAP,
).reduce((acc: Record<string, string>, [key, value]) => {
  acc[value] = key;
  return acc;
}, {});
